/**
 * Rude survey launcher factory for Web SDK
 */
import UISurvey from "./../FloodgateCore/UISurvey/UISurvey";
import * as Window from "./../Window/Window";
import { Api, Utils } from "@ms-ofb/officefloodgatecore";
const {
  isNOU
} = Utils;
export default class RudeSurveyLauncherFactory {
  makeSurveyLauncher(survey) {
    if (this.AcceptsSurvey(survey)) {
      return new RudeSurveyLauncher(survey);
    }
    return null;
  }
  AcceptsSurvey(survey) {
    // This factory should accept any type that is not of type GenericMessagingSurface
    // This will ensure that a rude survey launcher is returned for any survey type old or new
    // as a launcher is needed to invoke survey activated callback
    if (!isNOU(survey) && survey.getType() !== Api.ISurvey.Type.GenericMessagingSurface) {
      return true;
    }
    return false;
  }
}
RudeSurveyLauncherFactory.LAUNCHER_TYPE = Api.ISurvey.LAUNCHER_TYPE_DEFAULT;
export class RudeSurveyLauncher {
  constructor(survey) {
    this.survey = survey;
  }
  launch() {
    Window.get().OfficeBrowserFeedback.floodgate.showSurvey(new UISurvey(this.survey));
  }
}